// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.contactemail.RentalManagerUserPropertyContactEmailWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { ListingAlias, UserPropertyContactEmailDeliverabilityResponseWebDto } from '../..';

interface PurgeParams {
  listingAlias: ListingAlias;
}

export const RentalManagerUserPropertyContactEmailWebApiHandler_purge_Path =
  '/api/web/v1/users/properties/contactEmail/purge';

/**
 * Purge contact email with bounce or spam report
 */
export const RentalManagerUserPropertyContactEmailWebApiHandler_purge = (
  getParams: PurgeParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<PurgeParams, never, UserPropertyContactEmailDeliverabilityResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyContactEmailWebApiHandler_purge_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
